package org.molap.geojson

import kotlinx.io.Source
import kotlinx.io.readString
import org.molap.dataframe.DataFrame

fun DataFrame.Companion.readGeoJson(json: String): GeoJSONDataFrame {
    return GeoJSONDataFrame(json)
}

fun DataFrame.Companion.readGeoJson(source: Source): GeoJSONDataFrame {
    return GeoJSONDataFrame(source.readString())
}